/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id: "us-east-1:2ee6932d-a71f-44e1-905c-f3e068916bd2",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_Hommtegtw",
  aws_user_pools_web_client_id: "51m53gj1vh4cdrc1aqa5250abo",
  oauth: {
    domain: "cognito.arrivo.ai",
    scope: ["phone", "email", "openid", "profile", "aws.cognito.signin.user.admin"],
    redirectSignIn: "https://tenantportal.arrivo.ai/Auth/",
    redirectSignOut: "https://tenantportal.arrivo.ai/",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_user_files_s3_bucket: "foliolensprod160448-production",
  aws_user_files_s3_bucket_region: "us-east-1",
  aws_appsync_graphqlEndpoint: "https://gkh7t5vam5cxtdnhlxhxgtw7we.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_apiKey: "da2-7el5tqrbu5e6xmqx6pgvzxvmnm",
  aws_mobile_analytics_app_id: "5f05f6f4a2874d668cf843829d1aa8ce",
  aws_mobile_analytics_app_region: "us-east-1",
};

export default awsmobile;
